import React from 'react';
import { Card, CardContent, Chip, Skeleton, Stack, Typography } from '@mui/material';

export type DashboardKpi = {
  label: string;
  value: string;
  deltaText?: string;
  chips?: string[];
};

export function KpiCard({ kpi, loading }: { kpi: DashboardKpi; loading?: boolean }) {
  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <Typography variant="body2" color="text.secondary">
            {kpi.label}
          </Typography>

          {kpi.chips?.length ? (
            <Stack direction="row" spacing={0.5}>
              {kpi.chips.map((c) => (
                <Chip key={c} label={c} size="small" sx={{ borderRadius: 2, fontWeight: 800 }} />
              ))}
            </Stack>
          ) : null}
        </Stack>

        {loading ? (
          <Skeleton variant="text" height={36} sx={{ mt: 1 }} />
        ) : (
          <Typography variant="h5" sx={{ mt: 1, fontWeight: 900 }}>
            {kpi.value}
          </Typography>
        )}

        {loading ? (
          <Skeleton variant="text" height={18} width="60%" />
        ) : kpi.deltaText ? (
          <Typography variant="caption" color="text.secondary">
            {kpi.deltaText}
          </Typography>
        ) : null}
      </CardContent>
    </Card>
  );
}
